import { Button, Card, Select, TextInput } from '@common/components'
import { Accordion, Box, ColorInput, Flex, Group, MultiSelect, NumberInput, Space, Switch, Text, Title, UnstyledButton } from '@mantine/core'
import React, { useState } from 'react'

import { Plus } from '@geist-ui/icons'

import styles from "./styles.module.scss"
import { apiInstance } from 'src/services'
import { useAlert } from '@common/hooks'
import { Doughnut, Line } from 'react-chartjs-2'
import { setSelectedDashboard, useAppDispatch, useAppSelector } from 'src/store'
import { shallowEqual } from 'react-redux'
import { Link } from 'react-router-dom'


type DataSet = {
    label: string,
    data: Array<number>,
    borderColor: string,
    backgroundColor: string,
    pointBackgroundColor: string,
    borderWidth: number,
    pointBorderWidth: number,
    labelBorderWidth: number,
    fill?: boolean,
    lineTension?: number,
    pointHoverRadius?: number,
    pointRadius?: number,
    pointHitRadius?: number,
}

const lineConfigPlaceHolder = {
    name: '',
    borderColor: '#035e11b0',
    backgroundColor: '#035e11b0',
    pointBackgroundColor: '#035e11b0',
    borderWidth: 0,
    pointBorderWidth: 0,
    labelBorderWidth: 0,
    lineTension: 0,
    pointHoverRadius: 0,
    pointRadius: 0,
    pointHitRadius: 0,
    fill: false,
}
const initialState = {
    CompliantScore: lineConfigPlaceHolder,
    Target: lineConfigPlaceHolder,
    Critical: lineConfigPlaceHolder
};
type SectionName = 'CompliantScore' | 'Target' | 'Critical';

type SectionFields = {
    name: string;
    borderColor: string;
    backgroundColor: string;
    pointBackgroundColor: string;
    borderWidth: number;
    pointBorderWidth: number;
    labelBorderWidth: number;
    lineTension: number;
    pointHoverRadius: number;
    pointRadius: number;
    pointHitRadius: number;
    fill: boolean;
};

export function LineChartOptionComponent({ editChart }: { editChart?: any }) {
    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const [formState, setFormState] = useState(editChart?.dataset ?? initialState);
    const [newChartName, setNewChartName] = useState(editChart?.chartName ?? "")
    const [showMessage, setShowMessage] = useState(false)
    const { showAlert } = useAlert()
    const dispatch = useAppDispatch();

    const handleChange = (
        section: SectionName,
        field: keyof SectionFields,
        value: SectionFields[keyof SectionFields]
    ) => {
        setFormState((prev: any) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value,
            },
        }));
    };

    const createChart = async () => {

        try {


            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "Line",
                dataSource: 'accessibility_score_progress',
                dataset: formState
            });

            if (response?.data?.id) {
                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))
                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);
                return
            }


            showAlert({
                id: 'error-creating',
                title: 'Create Chart Faild',
                variant: 'error',
                autoClose: 2000
            });
        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }

    async function UpdateChart(chartId: string) {
        try {

            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                // dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "Line",
                dataSource: 'accessibility_score_progress',
                dataset: formState
            });

            if (response?.data?.id) {
                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))
                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);
                return
            }


            showAlert({
                id: 'error-creating',
                title: 'Update Chart Faild',
                variant: 'error',
                autoClose: 2000
            });
        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }
    return (
        <React.Fragment>

            <TextInput
                error={!newChartName?.trim() ? 'Chart Name Can Not Be Left Empty' : null}
                withAsterisk
                label="Chart Name"
                type="text"
                value={newChartName}
                placeholder='Enter a Chart Name'
                onChange={(event) => setNewChartName(event.currentTarget.value)}
            />
            <Accordion>
                {(['CompliantScore', 'Target', 'Critical'] as SectionName[]).map((section, index) => {
                    return <Accordion.Item key={section} value={section}>
                        <Accordion.Control>
                            <p>{section == 'CompliantScore' ? 'Compliant Score' : section}</p>
                        </Accordion.Control>
                        <Accordion.Panel>
                            <TextInput
                                label="Name"
                                type="text"
                                value={formState[section].name}
                                placeholder="Enter a Field Name"
                                onChange={(event) => handleChange(section, 'name', event.currentTarget.value)}
                            />
                            <Space h={"sm"} />
                            <ColorInput
                                w="100%"
                                label="Border Color"
                                value={formState[section].borderColor}
                                onChange={(value) => handleChange(section, 'borderColor', value)}
                            />
                            <Space h={"sm"} />
                            <ColorInput
                                w="100%"
                                label="Background Color"
                                value={formState[section].backgroundColor}
                                onChange={(value) => handleChange(section, 'backgroundColor', value)}
                            />
                            <Space h={"sm"} />
                            <ColorInput
                                w="100%"
                                label="Point Background Color"
                                value={formState[section].pointBackgroundColor}
                                onChange={(value) => handleChange(section, 'pointBackgroundColor', value)}
                            />
                            <Space h={"sm"} />
                            <NumberInput
                                w="100%"
                                label="Border Width"
                                value={formState[section].borderWidth}
                                onChange={(value) => handleChange(section, 'borderWidth', value || 0)}
                            />
                            <Space h={"sm"} />
                            <NumberInput
                                w="100%"
                                label="Point Border Width"
                                value={formState[section].pointBorderWidth}
                                onChange={(value) => handleChange(section, 'pointBorderWidth', value || 0)}
                            />
                            <Space h={"sm"} />
                            <NumberInput
                                w="100%"
                                label="Label Border Width"
                                value={formState[section].labelBorderWidth}
                                onChange={(value) => handleChange(section, 'labelBorderWidth', value || 0)}
                            />
                            <Space h={"sm"} />
                            <NumberInput
                                w="100%"
                                label="Line Tension"
                                value={formState[section].lineTension}
                                onChange={(value) => handleChange(section, 'lineTension', value || 0)}
                            />

                            <NumberInput
                                w="100%"
                                label="Point Hover Radius"
                                value={formState[section].pointHoverRadius}
                                onChange={(value) => handleChange(section, 'pointHoverRadius', value || 0)}
                            />
                            <Space h={"sm"} />
                            <NumberInput
                                w="100%"
                                label="Point Radius"
                                value={formState[section].pointRadius}
                                onChange={(value) => handleChange(section, 'pointRadius', value || 0)}
                            />
                            <Space h={"sm"} />
                            <NumberInput
                                w="100%"
                                label="Point Hit Radius"
                                value={formState[section].pointHitRadius}
                                onChange={(value) => handleChange(section, 'pointHitRadius', value || 0)}
                            />
                            <Space h={"sm"} />
                            <Switch
                                w="100%"
                                label="Fill"
                                checked={formState[section].fill}
                                onChange={(event) => handleChange(section, 'fill', event.currentTarget.checked)}
                            />
                            <Space h={"sm"} />
                        </Accordion.Panel>
                    </Accordion.Item>
                })}
            </Accordion>

            {

                showMessage && <div className={styles.alertMessage}>
                    {newChartName} Has Been Added Successfully.
                </div>
            }

            <Space h={"sm"} />
            <Button
                disabled={!newChartName?.trim()}
                fullWidth color='dark-green' onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>{

                    editChart ? 'Update Chart' : 'Create Chart'

                }</Button>

        </React.Fragment>

    )
}



type CriteriaField = 'Passed' | 'Failed' | 'Tested';

type CriteriaState = Record<CriteriaField, {
    label: string;
    backgroundColor: string;
}>
export function PieChartOptionComponent({ editChart , dataSource }: { editChart?: any, dataSource?:string }) {
    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const [criteriaState, setCriteriaState] = useState<CriteriaState>(editChart?.dataset ?? {
        Passed: { fieldName: 'Number Criteria Passed', backgroundColor: '#035e11b0' },
        Failed: { fieldName: 'Number Criteria Failed', backgroundColor: '#da604e' },
        Tested: { fieldName: 'Number Criteria Tested', backgroundColor: '#2A2B4B' },
    })

    const [showMessage, setShowMessage] = useState(false)
    const [newChartName, setNewChartName] = useState(editChart?.chartName ?? "")
    const dispatch = useAppDispatch();
    const handleCriteriaChange = (
        field: CriteriaField,
        key: 'fieldName' | 'backgroundColor',
        value: string
    ) => {
        setCriteriaState((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                [key]: value,
            },
        }));
    };

    const createChart = async () => {

        try {

            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "Pie",
                dataSource: dataSource,
                dataset: criteriaState
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);
                return
            }
        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }

    const UpdateChart = async (chartId: string) => {

        try {

            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                chartName: newChartName,
                chartType: "Pie",
                dataSource: dataSource,
                dataset: criteriaState
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);
                return
            }
        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }
    const action = editChart ? 'Update' : 'Create'
    return (
        <React.Fragment>

            <TextInput
                error={!newChartName?.trim() ? 'Chart Name Must Not Be Left Empty' : null}
                withAsterisk={true}
                label="Chart Name"
                type="text"
                value={newChartName}
                placeholder='Enter a Chart Name'
                onChange={(event) => setNewChartName(event.currentTarget.value)}
            />


            {(['Passed', 'Failed', 'Tested'] as CriteriaField[]).map((field) => (
                <div key={field} style={{
                    display: 'grid',
                    alignItems: 'center',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '1rem'
                }} >
                    <TextInput
                        disabled
                        label="Field Name"
                        type="text"
                        placeholder={`Number Criteria ${field}`}
                        value={criteriaState[field]?.label}
                        onChange={(e) => handleCriteriaChange(field, 'fieldName', e.currentTarget.value)}
                    />
                    <ColorInput
                        label="Background Color"
                        value={criteriaState[field]?.backgroundColor}
                        onChange={(color) => handleCriteriaChange(field, 'backgroundColor', color)}
                    />
                </div>
            ))}


            {

                showMessage && <div className={styles.alertMessage}>
                    {newChartName} Has Been {action}d Successfully.
                </div>
            }


            <Button disabled={!newChartName?.trim()} onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>{action}</Button>
        </React.Fragment>
    );
}

type PriorityField = 'Warning' | 'Low' | 'Medium' | 'High' | 'Critical';
type PriorityState = Record<PriorityField, {
    label: string;
    backgroundColor: string;
}>
export function PieChartOptionComponentPriority({ editChart , dataSource }: { editChart?: any, dataSource?:string }) {
    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const [criteriaState, setCriteriaState] = useState<PriorityState>(editChart?.dataset ?? {
        Warning: { label: 'Warning', backgroundColor: '#DA604E' },
        Low: { label: 'Low', backgroundColor: '#A3E6E1' },
        Medium: { label: 'Medium', backgroundColor: '#2A2B4B' },
        High: { label: 'High', backgroundColor: '#FF8C00' },
        Critical: { label: 'Critical', backgroundColor: '#B22222' },
    })
    const [showMessage, setShowMessage] = useState(false)
    const [newChartName, setNewChartName] = useState(editChart?.chartName ?? "")
    const dispatch = useAppDispatch();
    const handleCriteriaChange = (
        field: PriorityField,
        key: 'label' | 'backgroundColor',
        value: string
    ) => {
        setCriteriaState((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                [key]: value,
            },
        }));
    };

    const createChart = async () => {

        try {
            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "Pie",
                dataSource: dataSource,
                dataset: criteriaState
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);
                return
            }
        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }

    const UpdateChart = async (chartId: string) => {

        try {

            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                chartName: newChartName,
                chartType: "Pie",
                dataSource: dataSource,
                dataset: criteriaState
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);
                return
            }
        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }
    const action = editChart ? 'Update' : 'Create'
    return (
        <React.Fragment>

            <TextInput
                error={!newChartName?.trim() ? 'Chart Name Must Not Be Left Empty' : null}
                withAsterisk={true}
                label="Chart Name"
                type="text"
                value={newChartName}
                placeholder='Enter a Chart Name'
                onChange={(event) => setNewChartName(event.currentTarget.value)}
            />


            {(['Warning' , 'Low' , 'Medium' , 'High' ,'Critical'] as PriorityField[]).map((field) => (
                <div key={field} style={{
                    display: 'grid',
                    alignItems: 'center',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '1rem'
                }} >
                    <TextInput
                        // disabled
                        label="Field Name"
                        type="text"
                        placeholder={`Number Criteria ${field}`}
                        value={criteriaState[field]?.label}
                        onChange={(e) => handleCriteriaChange(field, 'label', e.currentTarget.value)}
                    />
                    <ColorInput
                        label="Background Color"
                        value={criteriaState[field]?.backgroundColor}
                        onChange={(color) => handleCriteriaChange(field, 'backgroundColor', color)}
                    />
                </div>
            ))}


            {

                showMessage && <div className={styles.alertMessage}>
                    {newChartName} Has Been {action}d Successfully.
                </div>
            }


            <Button disabled={!newChartName?.trim()} onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>{action}</Button>
        </React.Fragment>
    );
}




export function SemicircleOption({ editChart }: { editChart?: any }) {




    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);

    const [color, setColor] = useState(editChart?.dataset?.color ?? "#035e11")
    const [newChartName, setNewChartName] = useState(editChart?.chartName ?? "")
    const [showMessage, setShowMessage] = useState(false)
    const dispatch = useAppDispatch();
    const createChart = async () => {

        try {

            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "SemiCircle",
                dataSource: 'vially_score',
                dataset: {
                    color,
                }
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);

                return
            }
        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }

    const UpdateChart = async (chartId: string) => {

        try {

            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                // dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "SemiCircle",
                dataSource: 'vially_score',
                dataset: {
                    color,
                }
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);

                return
            }
        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }

    const action = editChart ? 'Update' : 'Create'
    return <>
        <TextInput
            withAsterisk
            label="Chart Name"
            type="text"
            value={newChartName}
            error={ !newChartName?.trim() ? 'Chart Name Must Not be Left Empty': null }
            placeholder='Enter a Chart Name'
            onChange={(event) => setNewChartName(event.currentTarget.value)}
        />
        <Flex align={"center"} gap={"sm"}>

            <ColorInput
                withAsterisk
                w={"100%"}
                label="Progress Color"
                value={color}
                onChange={setColor}
            />
        </Flex>
        {
            showMessage && <div className={styles.alertMessage}>
                {newChartName} Has Been {action}d Successfully.
            </div>
        }

        <Button disabled={!newChartName.trim() || !color} onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>{action}</Button>
    </>
}


type ChartItem = {
    label: string;
    color: string;
};
type SeverityLevel = 'warning' | 'medium' | 'low';

type SeverityState = Record<SeverityLevel, {
    label: string;
    color: string;
}>;
export function MultipleBarHorizantalOption({ editChart }: { editChart?: any }) {


    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const dispatch = useAppDispatch();


    const totalV = editChart?.dataset?.data?.find((d: any) => d.label === 'Total Issues');
    const closedV = editChart?.dataset?.data?.find((d: any) => d.label === 'Closed Issues');
    const newIssueV = editChart?.dataset?.data?.find((d: any) => d.label === 'New Issues');
    const openV = editChart?.dataset?.data?.find((d: any) => d.label === 'Open Issues');

    const [totalIssueColor, setTotaIssuesColor] = useState(totalV?.color ?? "#000")
    const [closedIssueColor, setClosedIssuesColor] = useState(closedV?.color ?? "#000")
    const [newIssueColor, setNewIssuesColor] = useState(newIssueV?.color ?? "#000")
    const [openIssueColor, setopenIssuesColor] = useState(openV?.color ?? "#000")




    const [showMessage, setShowMessage] = useState(false)
    const [newChartName, setNewChartName] = useState(editChart?.chartName ?? "")

    const createChart = async () => {

        try {


            const data = [
                { label: 'Total Issues', color: totalIssueColor },
                { label: 'Closed Issues', color: closedIssueColor },
                { label: 'New Issues', color: newIssueColor },
                { label: 'Open Issues', color: openIssueColor },
            ]
            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "multipleBar",
                dataSource: 'issues_count',
                dataset: { data }
            });

            if (response?.data?.id) {
                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))


                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);

                return
            }

        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }

    const UpdateChart = async (chartId: string) => {

        try {
            const data = [
                { label: 'Total Issues', color: totalIssueColor },
                { label: 'Closed Issues', color: closedIssueColor },
                { label: 'New Issues', color: newIssueColor },
                { label: 'Open Issues', color: openIssueColor },
            ]
            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                chartName: newChartName,
                chartType: "multipleBar",
                dataSource: 'issues_count',
                dataset: { data }
            });

            if (response?.data?.id) {
                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))


                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);

                return
            }

        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }

    const action = editChart ? 'Update' : 'Create'


    return (
        <React.Fragment>
            <TextInput
                withAsterisk={true}
                error={!newChartName?.trim() ? "Chart Name Must Not be Left Empty" : null}
                label="Chart Name"
                type="text"
                value={newChartName}
                placeholder='Enter a Chart Name'
                onChange={(event) => setNewChartName(event.currentTarget.value)}
            />

            <ColorInput
                size='md'
                label="Total Issues Color"
                value={totalIssueColor}
                onChange={(color) => setTotaIssuesColor(color)}
            />

            <ColorInput
                size='md'
                label="Closed Issues Color"
                value={closedIssueColor}
                onChange={(color) => setClosedIssuesColor(color)}
            />

            <ColorInput
                size='md'
                label="New Issues Color"
                value={newIssueColor}
                onChange={(color) => setNewIssuesColor(color)}
            />

            <ColorInput
                size='md'
                label="Open Issues Color"
                value={openIssueColor}
                onChange={(color) => setopenIssuesColor(color)}
            />
            {

                showMessage && <div className={styles.alertMessage}>
                    {newChartName} Has Been {action}d Successfully.
                </div>
            }

            <Button
                disabled={!newChartName?.trim()}
                onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>Create</Button>
        </React.Fragment>
    );
}





type BarDataSet = {
    label: string;
    data: number[];
    backgroundColor: string[];
    borderWidth: number;
};

export function BarChartOptionComponent({ editChart, dataSource }: { editChart?: any, dataSource: string }) {
    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const dispatch = useAppDispatch();

    const [colors, setColors] = useState<string[]>(editChart?.dataset?.colors ?? ['#000']);
    const [chartLabel, setNewChartLabel] = useState(editChart?.dataset?.chartLabel ?? "")

    const [newChartName, setNewChartName] = useState(editChart?.chartName ?? "")
    const [showMessage, setShowMessage] = useState(false)


    const handleColorChange = (index: number, value: string) => {
        setColors((prev) => {
            const updated = [...prev];
            updated[index] = value;
            return updated;
        });
    };


    const addNewColor = () => {
        setColors((prev) => [...prev, '#000']);
    };
    const removeColor = (index: number) => {
        setColors((prev) => prev.filter((_, i) => i !== index));
    };

    const createChart = async () => {

        try {


            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "Bar",
                dataSource: dataSource,
                dataset: {
                    chartLabel,
                    colors
                }
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);
                setColors([])

                return
            }


        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }
    const UpdateChart = async (chartId: string) => {

        try {


            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                chartName: newChartName,
                chartType: "Bar",
                dataSource: dataSource,
                dataset: {
                    chartLabel,
                    colors
                }
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);
                setColors([])

                return
            }


        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }
    const action = editChart ? 'Update' : 'Create'
    return (
        <React.Fragment>
            <TextInput
                error={!newChartName?.trim() ? 'Chart Name Must Not Be Left Empty' : null}
                label="Chart Name"
                type="text"
                value={newChartName}
                placeholder='Enter a Chart Name'
                onChange={(event) => setNewChartName(event.currentTarget.value)}
            />

            <TextInput

                label="Chart Label"
                type="text"
                value={chartLabel}
                placeholder='Number of Issues'
                onChange={(event) => setNewChartLabel(event.currentTarget.value)}
            />
            <Flex direction="column" gap="sm">
                <Flex justify={"end"}>
                    <Button type="button" onClick={addNewColor}>
                        Add Color
                    </Button>
                </Flex>
                {colors.map((color, index) => (
                    <Flex key={index} align="end" gap="sm" w="100%">
                        <ColorInput
                            w="100%"
                            label={`Color ${index + 1}`}
                            value={color}
                            onChange={(value) => handleColorChange(index, value)}
                        />
                        <Button type="button" onClick={() => removeColor(index)}>
                            Remove
                        </Button>
                    </Flex>
                ))}

            </Flex>
            {

                showMessage && <div className={styles.alertMessage}>
                    {newChartName} Has Been {action}d Successfully.
                </div>
            }


            <Button disabled={!newChartName?.trim() || colors?.length == 0} onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>Create</Button>
        </React.Fragment>
    );
}

export function BarChartOptionComponentmost_common_success_criteria() {
    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);

    const [colors, setColors] = useState<string[]>(['']);
    const [chartLabel, setNewChartLabel] = useState("")
    const [newChartName, setNewChartName] = useState("")
    const [showMessage, setShowMessage] = useState(false)
    const dispatch = useAppDispatch();

    const handleColorChange = (index: number, value: string) => {
        setColors((prev) => {
            const updated = [...prev];
            updated[index] = value;
            return updated;
        });
    };


    const addNewColor = () => {
        setColors((prev) => [...prev, '']);
    };
    const removeColor = (index: number) => {
        setColors((prev) => prev.filter((_, i) => i !== index));
    };

    const createChart = async () => {

        try {


            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "Bar",
                dataSource: 'most_common_success_criteria',
                dataset: {
                    chartLabel,
                    colors
                }
            });

            if (response?.data?.id) {
                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))


                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);

                return
            }


        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }
    return (
        <React.Fragment>
            <TextInput

                label="Chart Name"
                type="text"
                value={newChartName}
                placeholder='Enter a Chart Name'
                onChange={(event) => setNewChartName(event.currentTarget.value)}
            />

            <TextInput

                label="Chart Label"
                type="text"
                value={chartLabel}
                placeholder='Number of Issues'
                onChange={(event) => setNewChartLabel(event.currentTarget.value)}
            />
            <Flex direction="column" gap="sm">
                <Flex justify={"end"}>
                    <Button type="button" onClick={addNewColor}>
                        Add Color
                    </Button>
                </Flex>
                {colors.map((color, index) => (
                    <Flex key={index + '-' + color} align="end" gap="sm" w="100%">
                        <ColorInput
                            w="100%"
                            label={`Color ${index + 1}`}
                            value={color}
                            onChange={(value) => handleColorChange(index, value)}
                        />
                        <Button type="button" onClick={() => removeColor(index)}>
                            Remove
                        </Button>
                    </Flex>
                ))}

            </Flex>
            {
                showMessage && <div className={styles.alertMessage}>
                    {newChartName} Has Been Added Successfully.
                </div>
            }
            <Button onClick={() => { createChart() }}>Create</Button>
        </React.Fragment>
    );
}

export function GaugeChartOptionComponent({ editChart, dataSource }: { editChart?: any, dataSource: string }) {

    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const [textColor, setTextColor] = useState<string>(editChart?.dataset?.textColor ?? '#000000');
    const [needleColor, setNeedleColor] = useState<string>(editChart?.dataset?.needleColor ?? '#464A4F');
    const [colors, setColors] = useState<string[]>(editChart?.dataset?.colors ?? ['#A3E6E1', '#DA604E']);
    const [colorValue, setColorValue] = useState<string>('#000000');
    const [newChartName, setNewChartName] = useState(editChart?.chartName ?? "")
    const [showMessage, setShowMessage] = useState(false)
    const dispatch = useAppDispatch();


    const addColor = () => {
        setColors([...colors, colorValue]);
        setColorValue('#000000');
    };

    const removeColor = (index: number) => {
        setColors(colors.filter((_, i) => i !== index));
    };

    const createChart = async () => {
        try {


            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "Gauge",
                dataSource: dataSource,
                dataset: {
                    textColor,
                    needleColor,
                    colors
                }
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);


                return
            }
        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }

    const UpdateChart = async (chartId: string) => {
        try {


            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                chartName: newChartName,
                chartType: "Gauge",
                dataSource: dataSource,
                dataset: {
                    textColor,
                    needleColor,
                    colors
                }
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);


                return
            }
        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }
    const action = editChart ? 'Update' : 'Create'
    return (
        <React.Fragment>
            <TextInput
                withAsterisk
                error={!newChartName?.trim() ? 'Chart Name Must Not be Left Empty' : null}
                label="Chart Name"
                type="text"
                value={newChartName}
                placeholder='Enter a Chart Name'
                onChange={(event) => setNewChartName(event.currentTarget.value)}
            />
            <Flex w="100%" justify="space-between">
                <Title order={2} size={16}>Gauge Chart Settings</Title>
            </Flex>


            <ColorInput
                withAsterisk
                label="Text Color"
                value={textColor}
                onChange={setTextColor}
            />

            <ColorInput
                withAsterisk
                label="Needle Color"
                value={needleColor}
                onChange={setNeedleColor}
            />

            <Box mt="md">
                <Flex justify="space-between" align="center">
                    <Title order={3} size={14}>Gauge Colors</Title>
                    <UnstyledButton onClick={addColor} className={styles['add-button']}>
                        <Plus size={20} />
                    </UnstyledButton>
                </Flex>
                <Space h={"sm"} />
                <ColorInput
                    withAsterisk
                    placeholder="Add color zone"
                    value={colorValue}
                    onChange={setColorValue}
                />

                <Box mt="sm">
                    {colors.map((color, index) => (
                        <div className={styles['grid-color']} key={index}>
                            <TextInput
                                className={styles['w-full']}
                                placeholder='' disabled value={color} />
                            <Button onClick={() => removeColor(index)}>Remove</Button>
                        </div>
                    ))}
                </Box>
            </Box>


            {

                showMessage && <div className={styles.alertMessage}>
                    {newChartName} Has Been {action}d Successfully.
                </div>
            }

            <Button
                disabled={!newChartName?.trim() || colors?.length == 0}
                onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>{action}</Button>
        </React.Fragment>
    );
}


export function WebsiteScoreChartOptionComponent({ editChart, dataSource }: { editChart?: any, dataSource: string }) {
 

    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const [newChartName, setNewChartName] = useState(editChart?.chartName ?? "")
    const [showMessage, setShowMessage] = useState(false)
    const [color, setColor] = useState<string>(editChart?.dataset?.color ?? '#ff0000');
    const dispatch = useAppDispatch();

    const createChart = async () => {

        try {
            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName: newChartName,
                chartType: "Table",
                dataSource,
                dataset: { color }
            });

            if (response?.data?.id) {
                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);

                return
            }

        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }

    const UpdateChart = async (chartId: string) => {

        try {
            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                chartName: newChartName,
                chartType: "Table",
                dataSource,
                dataset: { color }
            });

            if (response?.data?.id) {
                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setNewChartName("")
                }, 1000 * count);

                return
            }

        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }
    const action = editChart ? 'Update' : 'Create'

    return (
        <React.Fragment>
            <TextInput
                error={!newChartName?.trim() ? 'Chart Name Must Not Be Left Empty' : null}
                label="Chart Name"
                type="text"
                value={newChartName}
                placeholder='Enter a Chart Name'
                onChange={(event) => setNewChartName(event.currentTarget.value)}
            />

            <ColorInput
                label="Bar Color"
                value={color}
                onChange={(val) => setColor(val)}
            />

            {

                showMessage && <div className={styles.alertMessage}>
                    {newChartName} Has Been {action}d Successfully.
                </div>
            }
            <Button disabled={!newChartName?.trim() || !color} onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>{action}</Button>

        </React.Fragment>
    );
}



export const PieChart = ({ warning, medium, low, colors , high, critical , labels = ['Warning', 'Low', 'Medium', 'High', 'Critical' ] }: { warning: number, medium: number, low: number, colors?: Array<string>, high: number, critical: number , labels?: Array<string> }) => {
    const data = {
        labels,
        datasets: [
            {
                data: [warning, low, medium, high, critical],
                backgroundColor: colors,
                borderWidth: .5,
            },
        ],
    };

    const options = {
        plugins: {
            datalabels: {
                display: false,
                color: '#fff'
            },
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        return `${context.label}: ${context.raw}%`;
                    },
                },
            },
        },
    };
    return (
        <>

            <div style={{ width: '100%', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Doughnut width={"300"} data={data} options={options} />
            </div>
        </>
    );
};


type SiteListType = {
    siteUUID: string, score: number, name: string
}
interface DashboardTableRankingProps {
    webSitesData: Array<SiteListType>;
    color: string
}
export function DashboardTableRankingRisk({ webSitesData, color }: DashboardTableRankingProps) {

    const data = webSitesData?.filter((site => site.score < 50)) ?? []
    return (
        <table style={{
            border: "1px solid #ddd",
            borderCollapse: "collapse",
            width: '100%',
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            backgroundColor: "#f9f9f9"
        }}>
            <thead>
                <tr style={{
                    backgroundColor: "#f2f2f2",
                    borderBottom: "2px solid #ccc"
                }}>
                    <th style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "left",
                        fontWeight: "bold"
                    }}>Website Name</th>
                    <th style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "left"
                    }}>Score</th>
                </tr>
            </thead>
            <tbody>
                {data?.length > 0 ? data.map((item: SiteListType, index) => (
                    <tr
                        key={item?.siteUUID}
                        style={{
                            borderBottom: "1px solid #ddd"
                        }}>
                        <td style={{
                            border: "1px solid #ddd",
                            padding: "10px"
                        }}>
                            <Flex align={"center"} gap={"sm"} >
                                <span style={{ width: '20px', height: '20px', background: color, borderRadius: '1rem' }}></span>
                                <Link to={item.name} target='_blank'>{item.name}</Link>
                            </Flex>
                        </td>
                        <td style={{
                            padding: "10px",
                            border: "1px solid #ddd"
                        }}>{parseInt(String(item?.score))}%</td>
                    </tr>
                )
                ) : <tr>
                    <td colSpan={5} style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "center"
                    }}>No data available</td>
                </tr>
                }
            </tbody>
        </table>
    )
}

export function DashboardTableRanking({ webSitesData, color }: DashboardTableRankingProps) {
    const data = webSitesData?.filter((site => site.score >= 50)) ?? []
    return (
        <table style={{
            border: "1px solid #ddd",
            borderCollapse: "collapse",
            width: '100%',
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            backgroundColor: "#f9f9f9"
        }}>
            <thead>
                <tr style={{
                    backgroundColor: "#f2f2f2",
                    borderBottom: "2px solid #ccc"
                }}>
                    <th style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "left",
                        fontWeight: "bold"
                    }}>Website Name</th>
                    <th style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "left"
                    }}>Score</th>
                </tr>
            </thead>
            <tbody>
                {data?.length ? data.map((item: SiteListType, index) => (
                    <tr
                        key={item?.siteUUID}
                        style={{
                            borderBottom: "1px solid #ddd"
                        }}>
                        <td style={{
                            border: "1px solid #ddd",
                            padding: "10px"
                        }}>
                            <Flex align={"center"} gap={"sm"} >
                                <span style={{ width: '20px', height: '20px', background: color, borderRadius: '1rem' }}></span>
                                <Link to={item.name} target='_blank'>{item.name}</Link>
                            </Flex>
                        </td>
                        <td style={{
                            padding: "10px",
                            border: "1px solid #ddd"
                        }}>{parseInt(String(item?.score))}%</td>
                    </tr>
                )) :
                    <tr>
                        <td colSpan={5} style={{
                            border: "1px solid #ddd",
                            padding: "10px",
                            textAlign: "center"
                        }}>No data available</td>
                    </tr>
                }
            </tbody>
        </table>
    )
}


interface ScanProgessProps {
    issuesCountOverTime: {
        actual: Array<{
            date: string,
            totalIssues: number,
            closedIssues: number,
            openIssues: number
        }>
    },
    config: any
}
export function ScanProgressChart({ issuesCountOverTime, config }: ScanProgessProps) {

    const data = {
        labels: issuesCountOverTime?.actual.map(scan => scan.date),
        datasets: [
            {
                label: config?.TotalIssues?.fieldName ?? 'Total Issues',
                data: issuesCountOverTime?.actual.map(scan => scan.totalIssues),
                borderColor: config?.TotalIssues?.borderColor ?? '#2a2b4b',
                backgroundColor: config?.TotalIssues?.backgroundColor ?? '#2a2b4b',
                fill: config?.TotalIssues?.fill ?? false,
            },
            {
                label: config?.OpenIssues?.fieldName ?? 'Open Issues',
                data: issuesCountOverTime?.actual.map(scan => scan.openIssues),
                borderColor: config?.OpenIssues?.borderColor ?? '#035e11b0',
                backgroundColor: config?.OpenIssues?.backgroundColor ?? '#035e11b0',
                fill: config?.OpenIssues?.fill ?? false,
            },
            {
                label: config?.ClosedIssues?.fieldName ?? 'Closed Issues',
                data: issuesCountOverTime?.actual.map(scan => scan.closedIssues),
                borderColor: config?.ClosedIssues?.borderColor ?? '#035e11b0',
                backgroundColor: config?.ClosedIssues?.backgroundColor ?? '#035e11b0',
                fill: config?.ClosedIssues?.fill ?? false,
            },
            {
                label: config?.NewIssues?.fieldName ?? 'New Issues',
                data: issuesCountOverTime?.actual.map(scan => scan.openIssues),
                borderColor: config?.NewIssues?.borderColor ?? '#da604e',
                backgroundColor: config?.NewIssues?.backgroundColor ?? '#da604e',
                fill: config?.NewIssues?.fill ?? false,
            },
        ],
    };

    // Configure chart options
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: 'Total Issues Found by Automated Scan Over Time',
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem: any) => {
                        return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
                    },
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Scan Date',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Number of Issues',
                },
                beginAtZero: true,
            },
        },
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ width: '80%', margin: 'auto' }}>
                <Line data={data} options={options} />
            </div>

        </div>
    );
}

type IssueType = 'TotalIssues' | 'OpenIssues' | 'ClosedIssues' | 'NewIssues';
type IssueState = Record<IssueType, {
    fieldName: string;
    borderColor: string;
    backgroundColor: string;
    fill: boolean;
}>;
export function ScanProgressChartOptions({ editChart }: { editChart?: any }) {
    const { dashboard } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const [chartName, setChartName] = useState(editChart?.chartName ?? "")
    const [showMessage, setShowMessage] = useState(false)
    const [issueState, setIssueState] = useState<IssueState>(editChart?.dataset ?? {
        TotalIssues: { fieldName: 'Total Issues', borderColor: '#000', backgroundColor: '#000', fill: true },
        OpenIssues: { fieldName: 'Open Issues', borderColor: '#000', backgroundColor: '#000', fill: true },
        ClosedIssues: { fieldName: 'Closed Issues', borderColor: '#000', backgroundColor: '#000', fill: true },
        NewIssues: { fieldName: 'New Issues', borderColor: '#000', backgroundColor: '#000', fill: true },
    });
    const dispatch = useAppDispatch();

    const handleIssueChange = <K extends keyof IssueState[IssueType]>(
        type: IssueType,
        key: K,
        value: IssueState[IssueType][K]
    ) => {
        setIssueState((prev) => ({
            ...prev,
            [type]: {
                ...prev[type],
                [key]: value,
            },
        }));
    };

    const createChart = async () => {

        try {


            const response = await apiInstance.post(`reporttool/dashboard/charts`, {
                dashboardId: dashboard?.id,
                chartName,
                chartType: "Line",
                dataSource: 'total_issues_over_time',
                dataset: issueState
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setChartName("")
                }, 1000 * count);

                return
            }


        } catch (err) {
            console.log(`Create Chart Faild : ${err}`);
        }
    }

    const UpdateChart = async (chartId: string) => {

        try {

            const response = await apiInstance.put(`reporttool/dashboard/charts/${chartId}`, {
                chartName,
                chartType: "Line",
                dataSource: 'total_issues_over_time',
                dataset: issueState
            });

            if (response?.data?.id) {

                dispatch(setSelectedDashboard({ dashboard_id: response?.data?.dashboard_id }))

                var count = 7;
                setShowMessage(true)
                const timeout = setTimeout(() => {
                    setShowMessage(false)
                    setChartName("")
                }, 1000 * count);

                return
            }


        } catch (err) {
            console.log(`Update Chart Faild : ${err}`);
        }
    }

    const action = editChart ? 'Update' : 'Create'

    return (
        <div style={{ width: '100%' }}>
            <TextInput
                label='Chart Name'
                withAsterisk={true}
                error={!chartName?.trim() ? 'Chart Name Must Not Be Left Empty' : null}
                placeholder={'Total Issues Over Time'}
                value={chartName}
                onChange={(e) => setChartName(e.currentTarget.value)}
            />

            {(['TotalIssues', 'OpenIssues', 'ClosedIssues', 'NewIssues'] as IssueType[]).map((type) => (
                <div key={type}>
                    <p style={{ margin: 0 }}>{type.replace(/([A-Z])/g, ' $1').trim()}</p>
                    <Space h={"sm"} />
                    <TextInput
                        placeholder={type.replace(/([A-Z])/g, ' $1').trim()}
                        value={issueState[type].fieldName}
                        onChange={(e) => handleIssueChange(type, 'fieldName', e.currentTarget.value)}
                    />
                    <Space h={"sm"} />
                    <ColorInput
                        label="Border Color"
                        value={issueState[type].borderColor}
                        onChange={(color) => handleIssueChange(type, 'borderColor', color)}
                    />
                    <Space h={"sm"} />
                    <ColorInput
                        label="Background Color"
                        value={issueState[type].backgroundColor}
                        onChange={(color) => handleIssueChange(type, 'backgroundColor', color)}
                    />
                    <Space h={"sm"} />
                    <Switch
                        label="Fill"
                        checked={issueState[type].fill}
                        onChange={(e) => handleIssueChange(type, 'fill', e.currentTarget.checked)}
                    />
                </div>
            ))}

            {

                showMessage && <div className={styles.alertMessage}>
                    {chartName} Has Been {action}d Successfully.
                </div>
            }

            <Space h={"sm"} />
            <Button fullWidth disabled={!chartName?.trim()} onClick={() => { editChart ? UpdateChart(editChart?.id) : createChart() }}>Create</Button>
        </div>
    );
}